module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<section class="object-group">\n    <h3>'+
((__t=(item.field.label))==null?'':_.escape(__t))+
'</h3>\n</section>';
}
return __p;
};